import { render, staticRenderFns } from "./LiveHome.vue?vue&type=template&id=4f5398ee&scoped=true&"
import script from "./LiveHome.vue?vue&type=script&lang=js&"
export * from "./LiveHome.vue?vue&type=script&lang=js&"
import style0 from "./LiveHome.vue?vue&type=style&index=0&id=4f5398ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5398ee",
  null
  
)

export default component.exports